import { memo } from "react";
import { simpleFormatAmount } from "../../../../../../helpers/simpleFormatAmount";

export default memo(({ rowData, rowTotalKey, c, params, filters }: any) => {
  const data = rowData?.currencies?.[c.value.toLowerCase()];

  if (!data) {
    return "-";
  }

  const isTotalRow = rowData?.[rowTotalKey]?.includes(
    `Total ${params.totalCurrency}`
  );

  const currency = isTotalRow ? params.totalCurrency : c.value;

  if (filters.dataType === "Sum") {
    return simpleFormatAmount(data?.total, currency) || "-";
  }

  if (filters.dataType === "Sum ||") {
    return (
      simpleFormatAmount(
        Math.abs(data?.profit) + Math.abs(data?.loss),
        currency
      ) || "-"
    );
  }

  if (filters.dataType === "+/-") {
    return (
      (data?.profit ? simpleFormatAmount(data?.profit, currency) : "-") +
      "/" +
      (data?.loss ? simpleFormatAmount(data?.loss, currency) : "-")
    );
  }

  if (filters.dataType === "Count") {
    return data?.count;
  }

  if (filters.dataType === "Average") {
    return simpleFormatAmount(data?.average, currency) || "-";
  }

  return "-";
});
